import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, mb, p} from "@pg-design/helpers-css-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppSelector} from "../../../store/hooks";
import {ForYouModalStep} from "../../types/ForYouModalStep";

interface IProps {
    isDisabled?: boolean;
    isPlaceholder?: boolean;
    showStep?: boolean;
    onClick?: () => void;
}
//TODO check if onClick needed after all forms are ready
export const ForYouModalButton = (props: IProps) => {
    const modalStep = useAppSelector((state) => state.forYouModal.step);
    const {isMobile} = useUserDevice();
    const showStep = props.showStep && [ForYouModalStep.REGION, ForYouModalStep.CRITERIA, ForYouModalStep.USER].includes(modalStep);

    const buttonText = () => {
        if (props.isPlaceholder) {
            return "Przejdź dalej";
        }

        if (modalStep === ForYouModalStep.ADDITIONAL) {
            return "Zapisz";
        }

        if (modalStep === ForYouModalStep.USER) {
            return "Zakończ i wyślij";
        }

        return "Przejdź dalej";
    };

    if (isMobile) {
        return (
            <div css={sticky}>
                <Button variant="filled_primary" size="small" type="submit" css={buttonStyle} disabled={props.isDisabled} onClick={props.onClick}>
                    {buttonText()}
                </Button>
                {showStep && (
                    <Text variant="info_txt_2" align="center">
                        Krok {modalStep}/3
                    </Text>
                )}
            </div>
        );
    }

    return (
        <Button variant="filled_primary" size="small" type="submit" css={buttonStyle} disabled={props.isDisabled} onClick={props.onClick}>
            {buttonText()}
        </Button>
    );
};

const buttonStyle = css`
    width: 100%;
    ${mb(1)};
`;

const sticky = css`
    position: sticky;
    bottom: 0;
    z-index: 10001;
    margin-left: -${calculateRemSize(1.5)};
    margin-right: -${calculateRemSize(1.5)};
    ${p(2, 2, 1, 2)};
    background-color: #fff;
`;
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, mb, p} from "@pg-design/helpers-css-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppSelector} from "../../../store/hooks";
import {ForYouModalStep} from "../../types/ForYouModalStep";

interface IProps {
    isDisabled?: boolean;
    isPlaceholder?: boolean;
    showStep?: boolean;
    onClick?: () => void;
}
//TODO check if onClick needed after all forms are ready
export const ForYouModalButton = (props: IProps) => {
    const modalStep = useAppSelector((state) => state.forYouModal.step);
    const {isMobile} = useUserDevice();
    const showStep = props.showStep && [ForYouModalStep.REGION, ForYouModalStep.CRITERIA, ForYouModalStep.USER].includes(modalStep);

    const buttonText = () => {
        if (props.isPlaceholder) {
            return "Przejdź dalej";
        }

        if (modalStep === ForYouModalStep.ADDITIONAL) {
            return "Zapisz";
        }

        if (modalStep === ForYouModalStep.USER) {
            return "Zakończ i wyślij";
        }

        return "Przejdź dalej";
    };

    if (isMobile) {
        return (
            <div css={sticky}>
                <Button variant="filled_primary" size="small" type="submit" css={buttonStyle} disabled={props.isDisabled} onClick={props.onClick}>
                    {buttonText()}
                </Button>
                {showStep && (
                    <Text variant="info_txt_2" align="center">
                        Krok {modalStep}/3
                    </Text>
                )}
            </div>
        );
    }

    return (
        <Button variant="filled_primary" size="small" type="submit" css={buttonStyle} disabled={props.isDisabled} onClick={props.onClick}>
            {buttonText()}
        </Button>
    );
};

const buttonStyle = css`
    width: 100%;
    ${mb(1)};
`;

const sticky = css`
    position: sticky;
    bottom: 0;
    z-index: 10001;
    margin-left: -${calculateRemSize(1.5)};
    margin-right: -${calculateRemSize(1.5)};
    ${p(2, 2, 1, 2)};
    background-color: #fff;
`;
